import { getFileSample } from '../services/sample.services';

import FileSaver from 'file-saver';

export const downloadFile = async (file) => {
  const fileExtension = file.split('/').pop();
  const res = await getFileSample(file);
  const data = new Blob([res]);
  FileSaver.saveAs(data, fileExtension);
};
